import Vue from 'vue'
import {Toast} from 'mint-ui'
import 'mint-ui/lib/style.css'
import AppView from './view/components/AppView.vue'
import MovieCover from './view/components/MovieCover.vue'

Vue.prototype.$toast = Toast

Vue.component(AppView.name, AppView)
Vue.component(MovieCover.name, MovieCover)



// WEBPACK FOOTER //
// ./src/ui.js